import React from 'react';

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className='flex justify-center mt-4'>
      <ul className='inline-flex -space-x-px'>
        {pages.map((page) => (
          <li key={page}>
            <button
              onClick={() => onPageChange(page)}
              className={`px-3 py-2 leading-tight ${
                page === currentPage
                  ? 'bg-blue-500 text-white'
                  : 'bg-white border border-gray-300'
              } hover:bg-gray-200`}
            >
              {page}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;

// import React from 'react';

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//   const handleClick = (page) => {
//     onPageChange(page);
//   };

//   return (
//     <div className="flex justify-center mt-4">
//       {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//         <button
//           key={page}
//           onClick={() => handleClick(page)}
//           className={`mx-1 px-3 py-2 rounded ${
//             page === currentPage ? 'bg-blue-500 text-white' : 'bg-gray-200'
//           }`}
//         >
//           {page}
//         </button>
//       ))}
//     </div>
//   );
// };

// export default Pagination;

// import React from 'react';

// const Pagination = ({ page, pages, onChangePage }) => {
//   return (
//     <div className='flex justify-center mt-8'>
//       <button
//         onClick={() => onChangePage(page - 1)}
//         disabled={page === 1}
//         className='px-3 py-2 mx-1 bg-gray-200 text-gray-700 rounded disabled:opacity-50 disabled:cursor-not-allowed'
//       >
//         Previous
//       </button>
//       {[...Array(pages).keys()].map((p) => (
//         <button
//           key={p + 1}
//           onClick={() => onChangePage(p + 1)}
//           className={`px-3 py-2 mx-1 ${
//             p + 1 === page
//               ? 'bg-blue-500 text-white'
//               : 'bg-gray-200 text-gray-700'
//           } rounded`}
//         >
//           {p + 1}
//         </button>
//       ))}
//       <button
//         onClick={() => onChangePage(page + 1)}
//         disabled={page === pages}
//         className='px-3 py-2 mx-1 bg-gray-200 text-gray-700 rounded disabled:opacity-50 disabled:cursor-not-allowed'
//       >
//         Next
//       </button>
//     </div>
//   );
// };

// export default Pagination;

// import React from 'react';

// const Pagination = ({ page, pages, onChangePage }) => {
//   const pageNumbers = [];

//   for (let i = 1; i <= pages; i++) {
//     pageNumbers.push(i);
//   }

//   return (
//     <div className='flex justify-center mt-8'>
//       {pageNumbers.map((number) => (
//         <button
//           key={number}
//           onClick={() => onChangePage(number)}
//           className={`mx-1 px-3 py-2 rounded-lg ${
//             page === number
//               ? 'bg-blue-500 text-white'
//               : 'bg-gray-300 text-gray-700'
//           }`}
//         >
//           {number}
//         </button>
//       ))}
//     </div>
//   );
// };

// export default Pagination;
